import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import {
  doGetAllContacts,
  doCreateContact,
  doUpdateContact,
  doDeleteContact,
  doUploadContacts,
  doDeleteContacts,
} from "./thunk";

const contactsAdapter = createEntityAdapter({
  selectId: item => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const contactSlice = createSlice({
  name: "contact",
  initialState: {
    isFetching: false,
    status: "idle",
    metadata: {},
    entities: [],
    ids: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doGetAllContacts.pending, state => {
      state.isFetching = true;
      state.action = "list";
      state.status = "loading";
    });
    builder.addCase(doGetAllContacts.fulfilled, (state, action) => {
      const { contactLocations, meta } = action.payload;
      state.isFetching = false;
      state.status = "succeeded";
      state.metadata = meta;
      contactsAdapter.setAll(state, contactLocations);
    });
    builder.addCase(doGetAllContacts.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doUploadContacts.pending, state => {
      state.isFetching = true;
      state.action = "upload";
      state.status = "loading";
    });
    builder.addCase(doUploadContacts.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      contactsAdapter.upsertMany(state, action.payload);
    });
    builder.addCase(doUploadContacts.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doCreateContact.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doCreateContact.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      contactsAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doCreateContact.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doUpdateContact.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doUpdateContact.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      contactsAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doUpdateContact.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doDeleteContact.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doDeleteContact.fulfilled, (state, action) => {
      state.isFetching = false;
      state.status = "succeeded";
      state.message = action.payload.message;
      contactsAdapter.removeOne(state, action.meta.arg);
    });
    builder.addCase(doDeleteContact.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
    builder.addCase(doDeleteContacts.pending, state => {
      state.isFetching = true;
      state.status = "loading";
    });
    builder.addCase(doDeleteContacts.fulfilled, (state, action) => {
      state.isFetching = false;
      state.message = "bulk_delete_succeeded";
      contactsAdapter.removeMany(state, action.meta.arg.ids);
    });
    builder.addCase(doDeleteContacts.rejected, state => {
      state.isFetching = false;
      state.status = "failed";
    });
  },
});

export const {
  selectAll: selectAllContacts,
  selectById: selectContactById,
  selectIds: selectContactIds,
} = contactsAdapter.getSelectors(state => state.contact);

const { reducer: contactReducer } = contactSlice;
export default contactReducer;
